import {Product} from '@/_application/modules/products/model/product';

export const getRatingDataFromProduct = (product: Product) => {
    return {
        ...(product?.ratings_count && {
            ratingsCount: product.ratings_count,
        }),
        ...(product?.ratings_summary && {
            ratingSummary: product.ratings_summary,
        }),
    };
};
